import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { BusinessSiteDto } from "../components/Requests/useGetUsers";

export interface CarrierDto {
  id: string;
  name: string;
  number?: string;
  addressStreet?: string;
  addressCity?: string;
  addressState?: string;
  addressPostalCode?: string;
  addressCountry?: string;
  phone?: string;
  emailAddresses: string[];
  notes?: string;
  sites: BusinessSiteDto[];
}

const useGetCarriers = (options?: QueryOptions<CarrierDto[]>) => {
  const business = useSelectedBusiness();
  return useUserQuery<CarrierDto[]>({ path: `/api/businesses/${business.id}/carriers` }, options);
}

export default useGetCarriers;
